// Generated by draht-codegen - DO NOT EDIT
import { DrahtClient } from '@geist/drahtzieher-client';
import type { DrahtClientOptions } from '@geist/drahtzieher-client';
import { b } from '@ekelhaft-tools/beschau';

export const BrutalGenerateSbomInputSchema = b.object({ path: b.string() });
export type BrutalGenerateSbomInput = b.infer<typeof BrutalGenerateSbomInputSchema>;

export const BrutalGenerateSbomOutputSchema = b.object({ type: b.any() /* VortexManifest */ });
export type BrutalGenerateSbomOutput = b.infer<typeof BrutalGenerateSbomOutputSchema>;

export const BrutalSignArtifactInputSchema = b.object({ merkle_root: b.instanceof(Uint8Array) });
export type BrutalSignArtifactInput = b.infer<typeof BrutalSignArtifactInputSchema>;

export const BrutalSignArtifactOutputSchema = b.object({ signature: b.instanceof(Uint8Array) });
export type BrutalSignArtifactOutput = b.infer<typeof BrutalSignArtifactOutputSchema>;

export const BrutalExecuteFluxInputSchema = b.object({ source: b.string() });
export type BrutalExecuteFluxInput = b.infer<typeof BrutalExecuteFluxInputSchema>;

export const BrutalExecuteFluxOutputSchema = b.object({ status: b.string() });
export type BrutalExecuteFluxOutput = b.infer<typeof BrutalExecuteFluxOutputSchema>;

export class GeneratedBrutalClient extends DrahtClient {
  private connectionState: 'connected' | 'disconnected' = 'disconnected';

  constructor(options: DrahtClientOptions) {
    super({
      ...options,
      onConnected: () => {
        this.connectionState = 'connected';
        options.onConnected?.();
      },
      onDisconnected: () => {
        this.connectionState = 'disconnected';
        options.onDisconnected?.();
      },
    });
  }

  public isReady(): boolean {
    return this.connectionState === 'connected';
  }

  public async waitForReady(timeoutMs: number = 10_000): Promise<void> {
    if (this.isReady()) return;
    const startedAt = Date.now();
    await new Promise<void>((resolve, reject) => {
      const tick = () => {
        if (this.isReady()) {
          resolve();
          return;
        }
        if (Date.now() - startedAt >= timeoutMs) {
          reject(new Error(`waitForReady timed out after ${timeoutMs}ms`));
          return;
        }
        setTimeout(tick, 50);
      };
      tick();
    });
  }

  public subscribe(event: string, cb: (data: unknown) => void): () => void {
    return this.on(event, cb);
  }

  /**
   * Generates a 6D Vortex SBOM manifest for a directory.
   */
  public async brutalGenerateSbom(input: BrutalGenerateSbomInput): Promise<Blob> {
    const parsed = BrutalGenerateSbomInputSchema.parse(input);
    return await this.callBinary('brutal.generate_sbom', parsed);
  }

  /**
   * Signs a Vortex Merkle Root via PETSCHAFT.
   */
  public async brutalSignArtifact(
    input: BrutalSignArtifactInput,
  ): Promise<BrutalSignArtifactOutput> {
    const parsed = BrutalSignArtifactInputSchema.parse(input);
    const response = await this.call('brutal.sign_artifact', parsed);
    return BrutalSignArtifactOutputSchema.parse(response) as BrutalSignArtifactOutput;
  }

  /**
   * Compiles and executes a native FLUX DSL pipeline.
   */
  public async brutalExecuteFlux(input: BrutalExecuteFluxInput): Promise<BrutalExecuteFluxOutput> {
    const parsed = BrutalExecuteFluxInputSchema.parse(input);
    const response = await this.call('brutal.execute_flux', parsed);
    return BrutalExecuteFluxOutputSchema.parse(response) as BrutalExecuteFluxOutput;
  }
}
